const LogoutButton = (props) => {
    
    const {logout} = props;

    return (
        <> 
            <button className="btn" onClick={logout}>
                <span>Log out</span>
            </button>            
        </>
    );
}

export default LogoutButton;